// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-section-2 {
    position: relative;
    width: 100%;
    margin-bottom: 20rem;
}

.section-2-bg {
    width: 100%;
}

.services-section-2-content {
    position: absolute;
    top: 60%;
    left: 10%;
    background-color: #0B63E5;
    color: white;
    width: 700px;
    padding: 3% 1% 1% 2%;
    border-top-right-radius: 50px;
}

.services-section-head {
    font-size: var(--font-size3);
    margin: 0;
    font-weight: lighter;
}

.bold-head {
    font-weight: 1000;
}

.services-section-desc {
    font-size: var(--font-size4);
}

.services-section-2-content-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (min-width:300px) and (max-width:490px) {
    .services-section-2 {
        margin-bottom: 5rem;
        overflow: hidden;
    }

    .section-2-bg {
        width: 100vh;
    }

    .section-2-logo {
        width: 10%;
    }

    .services-section-2-content {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 90%;
        transform: translate(-50%, -50%);
    }

    .services-section-head {
        font-size: 1.5rem;
    }

    .services-section-desc {
        font-size: 0.65rem;
    }

    .itlogo {
        width: 10%;
    }
}

@media screen and (min-width:600px) and (max-width:1024px) {
    .services-section-2 {
        margin-bottom: 20rem;
    }

    .section-2-logo {
        width: 15%;
    }

    .services-section-2-content {
        width: 70%;
    }

    .services-section-head {
        font-size: 1.7rem;
    }

    .services-section-desc {
        font-size: 0.9rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Services/common/Section2.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".services-section-2 {\r\n    position: relative;\r\n    width: 100%;\r\n    margin-bottom: 20rem;\r\n}\r\n\r\n.section-2-bg {\r\n    width: 100%;\r\n}\r\n\r\n.services-section-2-content {\r\n    position: absolute;\r\n    top: 60%;\r\n    left: 10%;\r\n    background-color: #0B63E5;\r\n    color: white;\r\n    width: 700px;\r\n    padding: 3% 1% 1% 2%;\r\n    border-top-right-radius: 50px;\r\n}\r\n\r\n.services-section-head {\r\n    font-size: var(--font-size3);\r\n    margin: 0;\r\n    font-weight: lighter;\r\n}\r\n\r\n.bold-head {\r\n    font-weight: 1000;\r\n}\r\n\r\n.services-section-desc {\r\n    font-size: var(--font-size4);\r\n}\r\n\r\n.services-section-2-content-bottom {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .services-section-2 {\r\n        margin-bottom: 5rem;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .section-2-bg {\r\n        width: 100vh;\r\n    }\r\n\r\n    .section-2-logo {\r\n        width: 10%;\r\n    }\r\n\r\n    .services-section-2-content {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        width: 90%;\r\n        transform: translate(-50%, -50%);\r\n    }\r\n\r\n    .services-section-head {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .services-section-desc {\r\n        font-size: 0.65rem;\r\n    }\r\n\r\n    .itlogo {\r\n        width: 10%;\r\n    }\r\n}\r\n\r\n@media screen and (min-width:600px) and (max-width:1024px) {\r\n    .services-section-2 {\r\n        margin-bottom: 20rem;\r\n    }\r\n\r\n    .section-2-logo {\r\n        width: 15%;\r\n    }\r\n\r\n    .services-section-2-content {\r\n        width: 70%;\r\n    }\r\n\r\n    .services-section-head {\r\n        font-size: 1.7rem;\r\n    }\r\n\r\n    .services-section-desc {\r\n        font-size: 0.9rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
